import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import WhatsAppButton from "@/components/WhatsAppButton";
import AdminLayout from "@/components/AdminLayout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import QuoteBuilder from "@/pages/QuoteBuilder";
import ClientDashboard from "@/pages/ClientDashboard";
import ClientQuotations from "@/pages/ClientQuotations";
import ClientOrders from "@/pages/ClientOrders";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminQuotations from "@/pages/AdminQuotations";
import AdminKanban from "@/pages/AdminKanban";
import AdminCalendar from "@/pages/AdminCalendar";
import AdminCRM from "@/pages/AdminCRM";
import AdminPricing from "@/pages/AdminPricing";
import AdminSettings from "@/pages/AdminSettings";
import AdminNewQuotation from "@/pages/AdminNewQuotation";

function ProtectedRoute({ role }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-sm text-[#94A3B8]">Cargando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return <Outlet />;
}

function PublicLayout() {
  return (
    <>
      <Navbar />
      <Outlet />
      <WhatsAppButton />
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes with Navbar */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/cotizar" element={<QuoteBuilder />} />
          </Route>

          {/* Auth routes (no navbar) */}
          <Route path="/login" element={<Login />} />
          <Route path="/registro" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Client portal */}
          <Route element={<PublicLayout />}>
            <Route element={<ProtectedRoute role="client" />}>
              <Route path="/portal" element={<ClientDashboard />} />
              <Route path="/portal/cotizaciones" element={<ClientQuotations />} />
              <Route path="/portal/pedidos" element={<ClientOrders />} />
              <Route path="/portal/pedidos/:orderId" element={<ClientOrders />} />
            </Route>
          </Route>

          {/* Admin panel */}
          <Route element={<ProtectedRoute role="admin" />}>
            <Route element={<AdminLayout />}>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/cotizaciones" element={<AdminQuotations />} />
              <Route path="/admin/produccion" element={<AdminKanban />} />
              <Route path="/admin/calendario" element={<AdminCalendar />} />
              <Route path="/admin/clientes" element={<AdminCRM />} />
              <Route path="/admin/precios" element={<AdminPricing />} />
              <Route path="/admin/configuracion" element={<AdminSettings />} />
              <Route path="/admin/nueva-cotizacion" element={<AdminNewQuotation />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
